import * as React from 'react'
import Banner from 'app/shared/components/Banner'
import { useBanner } from 'app/shared/hooks/util/banner.hook'

const PgBanner: React.FC = () => {
    const mainBanner = useBanner('main')
    const productBanner = useBanner('product')

    return (
        <div style={{ padding: '0.8em' }}>
            <p>메인 베너 테스트</p>
            <Banner items={mainBanner} />
            <br />
            <br />
            <p>상품몰 베너 테스트</p>
            <Banner items={productBanner} />
        </div>
    )
}
export default PgBanner
